<template>
  <ConfigProvider :locale="localeMap[locale].ant">
    <router-view />
  </ConfigProvider>
</template>
<script lang="ts" setup>
  import { computed, reactive, watch } from 'vue'
  import { ConfigProvider } from 'ant-design-vue'
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import zhHK from 'ant-design-vue/lib/locale-provider/zh_TW'
  import msMY from 'ant-design-vue/lib/locale-provider/ms_MY'
  import enGB from 'ant-design-vue/lib/locale-provider/en_GB'
  // 这里组件库中没有zh_hk ,使用zh_TW语言包
  // import enUS from 'ant-design-vue/lib/locale-provider/en_US'
  import { Locale } from 'ant-design-vue/lib/locale-provider'
  import dayjs from 'dayjs'
  // import { useRouter } from 'vue-router'
  import 'dayjs/locale/zh-cn.js'
  import 'dayjs/locale/zh-hk.js'
  import 'dayjs/locale/ms.js'
  import 'dayjs/locale/en.js'
  // import 'dayjs/locale/en.js'
  import { useSettingStore, useAuthStore } from '@jms/store'
  import LangType from '@jms/utils/enums/LangType'
  // import useMatomo from '@jms/hooks/useMatomo'
  import { useValidationProvider } from './hooks/useValidationProvider'
  import { useSubpackageName } from './hooks/useSubpackageName'

  // 注入全局校验规则
  useValidationProvider()
  useSubpackageName()

  // const router = useRouter()
  // const authStore = useAuthStore()
  // const matomo = useMatomo()
  type Lang = keyof typeof LangType
  const sysSetting = useSettingStore()
  const localeMap = reactive<Record<Lang, { ant: Locale; dayjs: string }>>({
    zh: {
      ant: zhCN,
      dayjs: 'zh-ch'
    },
    hk: {
      ant: zhHK,
      dayjs: 'zh-hk'
    },
    my: {
      ant: msMY,
      dayjs: 'ms'
    },
    en: {
      ant: enGB,
      dayjs: 'en'
    }
  })
  const locale = computed(() => sysSetting.locale)
  dayjs.locale((localeMap[locale.value] || localeMap['zh']).dayjs)

  watch(
    () => locale.value,
    (c) => {
      dayjs.locale((localeMap[c] || localeMap['zh']).dayjs)
    }
  )
  // watch(
  //   () => router.currentRoute.value,
  //   (newValue: any) => {
  //     // 这里延迟是因为matomo sdk加载是异步非阻塞加载，所以为了能正确的获取到window上matomo的实例，我们这里会有略微延迟
  //     setTimeout(() => {
  //       /**
  //        * 记录跳转页面及页面标题  userAccount及id均为业务系统数据，此处做拼接传入
  //        **/
  //       const name =
  //         authStore.userInfo?.userAccount !== undefined
  //           ? `${authStore.userInfo?.userAccount} | ${authStore.userInfo?.id}`
  //           : ''
  //       // matomo.setUserId(name)
  //       // matomo.setCustomUrl(window.location.href)
  //       // matomo.trackPageView(router.currentRoute.value.meta.title)
  //     }, 500)
  //   }
  // )
</script>
<style>
  #app {
    font-family: PingFangSC, PingFangSC-Regular;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    min-width: 1440px;
  }
</style>
